import { Component, Input, OnInit } from '@angular/core';
import { PageFavorite } from '../../../../../models/page-favorite';
import { CommunicationService } from '../../../../../services/communication.service';
import { ChapterService } from '../../../../../services/chapter.service';
import { SidebarService } from '../../../../../services/sidebar.service';
import { PageFavoriteService } from '../../../../../services/page-favorite.service';
import { PageService } from '../../../../../services/page.service';
import { PageChangedEvent } from '../../../../../utils/events/page-changed-event';
import { environment } from '../../../../../../environments/environment';
import { QuickLink } from '../../../../../models/quick-link';
import { QuickLinkService } from '../../../../../services/quick-link.service';
import { HomeworkService } from '../../../../../services/homework.service';
import { AssetPipe } from '../../../../../pipes/asset.pipe';

@Component({
    selector: 'sidebar-single-page-favorite',
    templateUrl: './single-page-favorite.component.html',
    styleUrls: ['./single-page-favorite.component.scss'],
    standalone: true,
    imports: [
        AssetPipe
    ]
})
export class SinglePageFavoriteComponent implements OnInit {

    @Input() pageFavorite: PageFavorite;

    favoriteName: string;
    realPageNumber: number;
    sideNumberToShow: number;
    private quicklink: QuickLink;

    constructor(private communicationService: CommunicationService,
                private chapterService: ChapterService,
                private sidebarService: SidebarService,
                private pageFavoriteService: PageFavoriteService,
                private quicklinkService: QuickLinkService,
                private homeworkService: HomeworkService,
                private pageService: PageService) {
    }

    ngOnInit(): void {
        this.sideNumberToShow = this.getRealPageNumber();
        this.getFavoriteName();
        this.realPageNumber = this.getRealPageNumber();
        this.quicklink = this.quicklinkService.getAllQuickLinksOfPage(this.pageFavorite.pageId).all().filter(value => {
            return value.slug === this.pageFavorite.assignmentSlug;
        })[0];
    }

    turnToPage(): void {
        const pageChangedEvent = new PageChangedEvent();
        pageChangedEvent.moveToPage = this.pageFavorite.index;
        this.communicationService.announcePageTurn(pageChangedEvent);

        if (window.window.innerWidth <= (environment.mobileBreakPoint + 1)) {
            this.sidebarService.closeSidebar();
        }
        this.pageFavoriteService.logUsage(this.pageFavorite);
    }

    /**
     * On click event handler
     *
     * @param $event
     * @return {boolean}
     */
    openQuicklink($event): boolean {
        if (this.quicklink.isHSM()) {
            return this.homeworkService.openQuicklink(this.quicklink, this.pageFavorite.pageId, $event);
        }

        return this.quicklinkService.openQuicklink(this.quicklink);
    }

    private getRealPageNumber(): number {
        return this.pageService.getRealPageNumber(this.pageFavorite.index);
    }

    private getFavoriteName(): void {
        if (this.pageFavorite.assignmentSlug) {
            this.favoriteName = `Aufgabe ${this.pageFavorite.assignmentSlug}`;

            return;
        }

        this.chapterService.getChapterFromIndex(this.pageFavorite.index)
            .then(result => {

                if (!result) {
                    this.favoriteName = 'Lesezeichen Seite ...';

                    return;
                }

                this.chapterService.getChapterHierarchyFromChapter(result).then(hierarchy => {
                    this.favoriteName = `${hierarchy.join('.')}. ${result.title}`;
                });
            });
    }

    onKeyDown($event: KeyboardEvent): void {
        if ($event.key !== 'Enter' && $event.key === 'Space') {
            return;
        }

        this.turnToPage();
    }
}
